/**
 * Video models available for content-test variant generation.
 *
 * Mirrors the backend allowlist in
 * `apps/api/.../content-test/content-test-asset-generator.agent.ts`
 * (`veo-3.1`). Kept content-test-scoped rather than
 * reusing the chat feature's broader `SUPPORTED_VIDEO_MODELS`, which exposes a
 * different set of models — the two lists are allowed to diverge.
 */
/* eslint-disable i18next/no-literal-string -- vendor model and provider names */
export const VIDEO_VARIANT_MODELS = [
  { label: 'Veo 3.1', value: 'veo-3.1', provider: 'Google' },
] as const;
/* eslint-enable i18next/no-literal-string */

/** Preselected when the user switches variant generation to video. */
export const DEFAULT_VIDEO_VARIANT_MODEL = 'veo-3.1';
